import { createSelector } from 'reselect';
import max from 'lodash/max.js';

const uploads = createSelector(
  state => state.uploadImages,
  images => images.uploadImages,
);

export const maxColorSelector = createSelector(
 uploads,
  (images) => {
    const imgs = images.map(img => img.logoColors);
   const maximum = max(imgs);
   return maximum;
  },
);
